import { useEffect, useState } from "react";
import { getStoredLanguage, normalizeLanguage } from "../services/language";

const readInterfaceLanguage = (preferredLanguage) =>
  normalizeLanguage(preferredLanguage || getStoredLanguage());

export const useInterfaceLanguage = (preferredLanguage) => {
  const [language, setLanguage] = useState(() => readInterfaceLanguage(preferredLanguage));

  useEffect(() => {
    setLanguage(readInterfaceLanguage(preferredLanguage));
  }, [preferredLanguage]);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const handleLanguageChange = (event) => {
      setLanguage(readInterfaceLanguage(event?.detail?.language));
    };
    const handleStorageChange = (event) => {
      if (event?.key && event.key !== "xima_ui_language") return;
      setLanguage(readInterfaceLanguage());
    };

    window.addEventListener("xima:languagechange", handleLanguageChange);
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("xima:languagechange", handleLanguageChange);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = language;
    }
  }, [language]);

  return language;
};
